import { Injectable } from '@angular/core';

@Injectable()
export class UserLoginService {

    constructor(){
        
    }

    RevisarUsuarioLogueado(){
        //console.log("session ",localStorage.getItem('calidad_user_tag_1'));
        let userLogin=localStorage.getItem('calidad_user_tag_1').replace(/["']/g, "");
        let varianle=JSON.parse(localStorage.getItem('calidad_user_tag_1'));

        //userLogin=userLogin.replace(/\"/g, "");
        let numUserNameLogin=userLogin.indexOf("name");
        userLogin=userLogin.substring(numUserNameLogin+(5),userLogin.length-1)
        console.log("userLogin",varianle.name);
        return userLogin;
      }

   

}